import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { App } from './views';
import reportWebVitals from './reportWebVitals';
import KaveriAppStore from './store/kaveriappstore';

import './index.scss';

ReactDOM.render(
    <React.StrictMode>
        <Provider store={KaveriAppStore}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
